// Copyright (c) 2017 Deere & Company

import ReimbursementSummaryClaims from '../../reimbursement-summary/claims/state-connector';

export default {
    component: ReimbursementSummaryClaims,
    name: 'CLAIMS',
    path: 'claims'
};



// WEBPACK FOOTER //
// ./src/routes/reimbursement-summary/claims.js